<script setup lang="ts">
import type {OfferFilter, OfferFilters} from "@/types/Wiser/offer.ts";
import {inject, onMounted, ref, watch} from "vue";
import {apiClient} from "@/api/http.ts";

const model = defineModel<OfferFilter>({required: true});
const filters = ref<OfferFilters>({offertestatus:''})
watch(filters, (newValue) => {
  const filterString = Object.entries(newValue)
    .filter(([, value]) => value !== '')
    .map(([key, value]) => `${key}${['title'].includes(key)?'%=':'='}${encodeURIComponent(value)}`)
    .join(',')
  model.value.filters = encodeURI(filterString);
}, {deep: true})
const offerStates = inject('offerStates')
</script>

<template>
  <form class="wiser-filter__form offer-filter__form">
    <input v-model="filters.id" placeholder="Wiser ID" type="text" />
    <select v-model="filters.offertestatus">
      <option value="" class="placeholder">Offerte status</option>
      <option v-for="(offerState, key) in offerStates" :value="key" :key="key">{{ offerState }}</option>
    </select>
    <input v-model="filters.offertedatum" placeholder="Offertedatum" type="text" />
    <select v-model="model.page">
      <option v-for="num of [...Array(25).keys()]" :value="String(num + 1)">{{ num + 1 }}</option>
    </select>
    <select v-model="model.perPage">
      <option v-for="num of [...Array(4).keys()]" :value="String((num + 1)*25)">{{ (num + 1)*25 }}</option>
    </select>
  </form>
</template>

<style scoped>
 form {
   width: 100%;
 }
</style>
